import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import GetFreeEstimateButton from './GetFreeEstimateButton';

const {FiHome,FiSun,FiDroplet,FiTool}=FiIcons;

const Services=()=> {
  const services=[ 
    {
      icon: FiHome,
      title: 'Interior Painting',
      description: 'Transform your living spaces with expert interior painting. From single rooms to whole-house projects.',
      features: [ 
        'Color consultation',
        'Wall preparation & repair',
        'Premium paint selection',
        'Clean,precise finish',
        'Furniture protection' 
      ],
      image: 'https://images.unsplash.com/photo-1598928636135-d146006ff4be?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80'
    },
    {
      icon: FiSun,
      title: 'Exterior Painting',
      description: 'Boost your curb appeal and protect your home with professional exterior painting services.',
      features: [ 
        'Weather-resistant paints',
        'Surface preparation',
        'Trim & detail work',
        'Deck & fence staining',
        'Long-lasting protection' 
      ],
      image: 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80'
    },
    {
      icon: FiTool,
      title: 'Cabinet Painting',
      description: 'Revitalize your kitchen or bathroom with professional cabinet painting that transforms your space without a full renovation.',
      features: [ 
        'Custom color matching',
        'Thorough preparation',
        'Durable finish options',
        'Hardware replacement',
        'Quick turnaround time' 
      ],
      image: 'https://cabinetdoorsnmore.com/cdn/shop/articles/pexels-tamil-king-3214064_1_70deb040-e389-4af6-8ff4-8005df9e84bb_1400x.progressive.jpg?v=1639092567'
    },
    {
      icon: FiDroplet,
      title: 'Power Washing',
      description: 'Restore your property\'s beauty with professional power washing for driveways,decks,and siding.',
      features: [ 
        'House siding cleaning',
        'Driveway & walkways',
        'Deck & patio restoration',
        'Eco-friendly solutions',
        'Pre-paint preparation' 
      ],
      image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752980796141-blob'
    } 
  ];

  return ( 
    <section id="services" className="py-20 bg-white"> 
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
        {/* Section Header */} 
        <motion.div 
          initial={{opacity: 0,y: 20}} 
          whileInView={{opacity: 1,y: 0}} 
          transition={{duration: 0.8}} 
          viewport={{once: true}} 
          className="text-center mb-16" 
        > 
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4"> 
            Professional Services 
          </h2> 
          <div className="w-20 h-1 bg-blue-600 rounded-full mx-auto mb-6"></div> 
          <p className="text-xl text-gray-600 max-w-3xl mx-auto"> 
            Quality craftsmanship meets reliable service. From interior touch-ups to complete exterior makeovers,I bring expertise and care to every project. 
          </p> 
        </motion.div> 

        {/* Services Grid */} 
        <div className="space-y-16"> 
          {services.map((service,index)=> ( 
            <motion.div 
              key={index} 
              initial={{opacity: 0,y: 50}} 
              whileInView={{opacity: 1,y: 0}} 
              transition={{duration: 0.8,delay: index * 0.2}} 
              viewport={{once: true}} 
              className={`grid lg:grid-cols-2 gap-12 items-center ${index % 2===1 ? 'lg:grid-flow-col-dense' : ''}`} 
            > 
              {/* Content */} 
              <div className={`space-y-6 ${index % 2===1 ? 'lg:col-start-2' : ''}`}> 
                <div className="flex items-center space-x-4"> 
                  <div className="bg-blue-100 p-3 rounded-xl"> 
                    <SafeIcon icon={service.icon} className="w-8 h-8 text-blue-600" /> 
                  </div> 
                  <h3 className="text-2xl lg:text-3xl font-bold text-gray-900"> 
                    {service.title} 
                  </h3> 
                </div> 
                <p className="text-lg text-gray-600 leading-relaxed"> 
                  {service.description} 
                </p> 
                <div className="space-y-3"> 
                  <h4 className="font-semibold text-gray-900">What's Included:</h4> 
                  <ul className="space-y-2"> 
                    {service.features.map((feature,idx)=> ( 
                      <li key={idx} className="flex items-center space-x-3"> 
                        <div className="w-2 h-2 bg-blue-600 rounded-full"></div> 
                        <span className="text-gray-600">{feature}</span> 
                      </li> 
                    ))} 
                  </ul> 
                </div> 
                
                <GetFreeEstimateButton>
                  Get Quote for {service.title}
                </GetFreeEstimateButton>
              </div> 

              {/* Image */} 
              <div className={`relative ${index % 2===1 ? 'lg:col-start-1' : ''}`}> 
                <div className="relative rounded-2xl overflow-hidden shadow-xl"> 
                  <img 
                    src={service.image} 
                    alt={service.title} 
                    className="w-full h-80 object-cover" 
                  /> 
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div> 
                </div> 
              </div> 
            </motion.div> 
          ))} 
        </div> 
      </div> 
    </section> 
  );
};

export default Services;